"use strict";

// Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };

    hrtime = process.hrtime;

    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };

    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };

    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };

    loadTime = new Date().getTime();
  }
}).call(void 0);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wZXJmb3JtYW5jZS1ub3cuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLENBQUEsWUFBQTtBQUFBLE1BQUEsY0FBQSxFQUFBLE1BQUEsRUFBQSxRQUFBLEVBQUEsY0FBQSxFQUFBLFlBQUEsRUFBQSxNQUFBOztBQUFBLE1BQUcsT0FBQSxXQUFBLEtBQUEsV0FBQSxJQUFBLFdBQUEsS0FBQSxJQUFBLElBQWlCLFdBQVcsQ0FBL0IsR0FBQSxFQUFBO0FBQ0UsSUFBQSxNQUFNLENBQU4sT0FBQSxHQUFpQixZQUFBO2FBQUcsV0FBVyxDQUFYLEdBQUEsRTtBQUR0QixLQUNFO0FBREYsR0FBQSxNQUVLLElBQUcsT0FBQSxPQUFBLEtBQUEsV0FBQSxJQUFBLE9BQUEsS0FBQSxJQUFBLElBQWEsT0FBTyxDQUF2QixNQUFBLEVBQUE7QUFDSCxJQUFBLE1BQU0sQ0FBTixPQUFBLEdBQWlCLFlBQUE7YUFBRyxDQUFDLGNBQUEsS0FBRCxZQUFBLElBQW9DLEc7QUFBdkMsS0FBakI7O0FBQ0EsSUFBQSxNQUFBLEdBQVMsT0FBTyxDQUFDLE1BQWpCOztBQUNBLElBQUEsY0FBQSxHQUFpQiwwQkFBQTtBQUNmLFVBQUEsRUFBQTtBQUFBLE1BQUEsRUFBQSxHQUFLLE1BQUEsRUFBTDthQUNBLEVBQUcsQ0FBSCxDQUFHLENBQUgsR0FBQSxHQUFBLEdBQWMsRUFBRyxDQUFBLENBQUEsQztBQUZGLEtBQWpCOztBQUdBLElBQUEsY0FBQSxHQUFpQixjQUFBLEVBQWpCO0FBQ0EsSUFBQSxNQUFBLEdBQVMsT0FBTyxDQUFQLE1BQUEsS0FBbUIsR0FBNUI7QUFDQSxJQUFBLFlBQUEsR0FBZSxjQUFBLEdBUlosTUFRSDtBQVJHLEdBQUEsTUFTQSxJQUFHLElBQUksQ0FBUCxHQUFBLEVBQUE7QUFDSCxJQUFBLE1BQU0sQ0FBTixPQUFBLEdBQWlCLFlBQUE7YUFBRyxJQUFJLENBQUosR0FBQSxLQUFhLFE7QUFBaEIsS0FBakI7O0FBQ0EsSUFBQSxRQUFBLEdBQVcsSUFBSSxDQUZaLEdBRVEsRUFBWDtBQUZHLEdBQUEsTUFBQTtBQUlILElBQUEsTUFBTSxDQUFOLE9BQUEsR0FBaUIsWUFBQTthQUFPLElBQUEsSUFBQSxHQUFKLE9BQUksS0FBbUIsUTtBQUExQixLQUFqQjs7QUFDQSxJQUFBLFFBQUEsR0FBZSxJQUFBLElBQUEsR0FMWixPQUtZLEVBQWY7O0NBaEJGLEUsSUFBQSIsInNvdXJjZVJvb3QiOiIuLiJ9